import { captureMessage, withScope } from "@sentry/react";
// TODO: Comment back in during 1393
// import clsx from "clsx";
import { FC, useMemo, useState } from "react";
// TODO: Comment back in during 1393
// import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import {
  Lightbox,
  LightboxConfiguration,
} from "@/components/Interface/Lightbox/Lightbox";
import { LoadingSpinner } from "@/components/Layout/LoadingSpinner/LoadingSpinner";
import theme from "@/themes/base";
import { DATATRANS_CALLBACK_URL } from "@/utils/apiUrls";
import { env } from "@/utils/environmentHelpers";
// TODO: Comment back in during 1393
// import { CARD_PROVIDERS_REQUIRING_3DS } from "@/utils/lightboxHelpers";
import { log } from "@/utils/log";

const callbackUrl = new URL(DATATRANS_CALLBACK_URL);
if (env.isDev) {
  callbackUrl.searchParams.append("debug", "true");
}

interface LightboxWrapperProps {
  transactionId: number | undefined;
  sign: string | undefined;
  enabled?: boolean;
  paymentProvider: string | undefined;
  // TODO: Comment back in during 1393
  // cardholderName?: string;
  // onCardholderNameChange?: (name: string) => void;
  // onCardholderNameBlur?: () => void;
}

export const LightboxWrapper: FC<LightboxWrapperProps> = ({
  transactionId,
  sign,
  enabled,
  paymentProvider,
  // TODO: Comment back in during 1393
  // cardholderName = "",
  // onCardholderNameChange,
  // onCardholderNameBlur,
}) => {
  // TODO: Comment back in during 1393
  // const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  // TODO: Comment back in during 1393
  // const [touched, setTouched] = useState(false);

  // TODO: Comment back in during 1393
  // const requires3dsCardholderName =
  //   !!paymentProvider && CARD_PROVIDERS_REQUIRING_3DS.includes(paymentProvider);

  // TODO: Comment back in during 1393
  // Reset touched when the parent clears the name (e.g. on provider change)
  // useEffect(() => {
  //   if (!cardholderName) {
  //     setTouched(false);
  //   }
  // }, [cardholderName]);

  const onLoaded = () => setIsLoading(false);
  const onOpened = () => null;
  const onCancelled = () => {
    setIsLoading(false);
  };
  const onError = (data: any) => {
    setIsLoading(false);
    log(`Error in payment process: ${data}`);
    withScope(function (scope) {
      scope.setTag("section", "onboarding");
      scope.setTag("onboardingStep", "checkout");
      scope.setTag("event", "lightboxError");
      scope.setContext("data", { data });
      captureMessage("A lightbox payment process resulted in an error.");
    });
  };
  const location = useLocation();
  const hashWithoutQuery = window.location.hash.split("?")[0];
  // The current path is a pathname like /static/ plus the hash,
  // which resembles the route, but we remove query params from the hash.
  const redirectUrls = useMemo(() => {
    const urls = {
      successUrl: "",
      cancelUrl: "",
      errorUrl: "",
    };
    const settings = ["success", "cancel", "error"] as const;
    settings.forEach((setting) => {
      const url = new URL(callbackUrl);
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("payment", setting);
      searchParams.delete("errorCode");
      url.searchParams.append(
        "redirect",
        `${hashWithoutQuery}?${searchParams.toString()}`,
      );
      urls[`${setting}Url`] = url.toString();
    });

    return urls;
  }, [location, hashWithoutQuery]);

  const config: LightboxConfiguration = {
    merchantId: env.isProd ? "3000013097" : "1100015891", // Merchant identifier provided to you by Datatrans.
    refno: `${transactionId}`, // Provided by the backend, this identifies the transaction that this is going to be.
    currency: "CHF", // The type of currency that will be used for the payment.
    sign: `${sign}`, // Transaction security parameter, provided by the backend.
    production: env.isProd,
    paymentmethod: ["ECA", "VIS", "PFC", "TWI"],
    themeConfiguration: {
      brandColor: theme["primary-100"],
    },
    ...redirectUrls,
    useAlias: "yes", // Save an alias for the entered payment mean so we can use it again
    // TODO: Comment back in during 1393
    // ...(cardholderName && {
    //   card: {
    //     "3D": {
    //       cardholder: {
    //         cardholderName,
    //       },
    //     },
    //   },
    // }),
  };

  // TODO: Comment back in during 1393
  // const cardholderNameReady = !requires3dsCardholderName || !!cardholderName;

  return (
    <>
      {isLoading && <LoadingSpinner />}
      {/* // TODO: Comment back in during 1393 */}
      {/* {requires3dsCardholderName && (
        <div className="mt-4">
          <label
            className="mb-2 block text-base font-semibold leading-normal text-black"
            htmlFor="cardholder-name"
          >
            {t("Onboarding.sections.checkout.cardholderName")}
          </label>
          <input
            id="cardholder-name"
            data-testid="cardholder-name-input"
            className={clsx(
              "w-full max-w-xs border bg-white py-3 pl-4 pr-4 text-base text-black",
              touched && !cardholderName ? "border-red-500" : "border-gray-300",
            )}
            type="text"
            value={cardholderName}
            onChange={(e) => onCardholderNameChange?.(e.target.value)}
            onBlur={() => {
              setTouched(true);
              onCardholderNameBlur?.();
            }}
            autoComplete="cc-name"
          />
          {touched && !cardholderName && (
            <p className="mt-1 text-xs font-medium text-error-100">
              {t("Onboarding.sections.checkout.cardholderNameRequired")}
            </p>
          )}
        </div>
      )} */}
      {enabled && paymentProvider && transactionId && (
        <Lightbox
          config={{ ...config, paymentmethod: [paymentProvider] }}
          onLoaded={onLoaded}
          onOpened={onOpened}
          onCancelled={onCancelled}
          onError={onError}
        />
      )}
    </>
  );
};
